import React from 'react';
import { useOrg } from '../../hooks/useOrg';
import OrgSwitcher from './OrgSwitcher';

/**
 * After org context is ready: blocks dashboard until multi-org user picks a hospital,
 * or shows error when the account has no organization membership.
 *
 * Exception: 'superadmin' accounts (created by bootstrapPlatform on a fresh instance)
 * are allowed through even without an organization — they need to reach
 * ManagementDashboard to initiate the SetupWizard and create the first organization.
 * Every other role keeps the existing blocking behavior unchanged.
 */
export default function AuthenticatedOrgGate({ children, userRole }) {
  const {
    isLoading,
    activeOrgId,
    isMultiOrg,
    hasOrganizationMembership
  } = useOrg();

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner" />
        <h2>Se încarcă...</h2>
      </div>
    );
  }

  const isSuperadminBootstrap = userRole === 'superadmin' && !hasOrganizationMembership;

  if (!hasOrganizationMembership && !isSuperadminBootstrap) {
    return (
      <div
        className="loading-container"
        style={{ maxWidth: 520, margin: '2rem auto', textAlign: 'center' }}
      >
        <p role="alert" style={{ fontSize: '1.05rem', lineHeight: 1.5 }}>
          Contul nu este asociat unei organizații. Contactează administratorul.
        </p>
      </div>
    );
  }

  if (isMultiOrg && activeOrgId === null) {
    return <OrgSwitcher onSelect={() => {}} />;
  }

  return <>{children}</>;
}
